












































import { Component, Vue, Ref } from 'vue-property-decorator';
import SolutionList from './components/solutionList.vue';
import SolutionDetail from './components/solutionDetail.vue';
import { statusList } from '@/utils/solution';
import { compareObj, ISearchTag, searchParamsConvertArray } from '@/utils/other';
import SearchModal from '@/components/searchModal/searchModal.vue';
import { solutionListInstance } from '@/model/SolutionListClass';
import { CHANGE_SOLUTION_STATUS, pubsub } from '@/utils/pubsub';
import { TagsViewModule } from '@/store/modules/tagsView';

type IRequirementInfo = IRequirement.IResponse.IRequirementInfo;
type ISearchSolution = ISolution.IRequest.ISearchSolution;
type ISolutionStatusTxt = ISolution.ISolutionStatus;
type ISolutionInfo = ISolution.IResponse.ISolutionInfo;
type ILabelInfo = ILabel.IResponse.ILabelInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;

let changeStatusEventToken = '';

@Component({
  name: 'Solution',
  components: {
    SolutionList,
    SolutionDetail,
    SearchModal,
  },
})
export default class Solution extends Vue {
  @Ref() private readonly searchModalRef!: SearchModal;
  private searchByStatus: ISolutionStatusTxt | 'All' = 'Paid';
  private searchStatusOption: Array<ISolutionStatusTxt | 'All'> = ['All', ...statusList];
  private searchByKeyword: string = '';
  private requirementForCreateSolution: IRequirementInfo | null = null;
  private solutionInfoForSearch: ISearchSolution = {};
  private searchTags: ISearchTag[] = [];
  private isInitData = false;
  private solutionListInstance = solutionListInstance;
  private listSpinning = false;
  private addLoading = false;
  private detailSpinning = false;
  get listData() {
    return this.solutionListInstance.list.data;
  }
  get currentSolution() {
    return this.solutionListInstance.list.current;
  }
  get activeId() {
    return this.currentSolution?.id;
  }
  get isMore() {
    return this.solutionListInstance.isMore;
  }
  private created() {
    this.initData();
    solutionListInstance.requestCategorys();
    this.bindEvent();
  }
  private activated() {
    this.initData();
  }
  private initData() {
    if (Object.keys(this.$route.params).length && !compareObj(this.$route.params, this.solutionInfoForSearch)) {
      this.solutionInfoForSearch = {...this.$route.params};
      this.searchTags = searchParamsConvertArray(this.solutionInfoForSearch);
      this.refreshSolutions();
      this.isInitData = true;
      TagsViewModule.ChangeView({...this.$route, params: {}});
      return;
    }
    if (!this.isInitData) {
      this.initSolutions({
        status: 'Paid',
      });
      this.isInitData = true;
    }
  }
  private destroyed() {
    this.unBindEvent();
    solutionListInstance.list.clearData();
  }
  private handleSearch() {
    this.removeSolutionInfoForSearch();
    const params: ISearchSolution = {};
    if (this.searchByStatus !== 'All') {
      params.status = this.searchByStatus;
    }
    if (this.searchByKeyword) {
      params.title = this.searchByKeyword;
    }
    this.initSolutions(params);
  }
  private handleCreate() {
    const requirementIdForCreate = this.solutionInfoForSearch.requirementId || '';
    this.solutionListInstance.createSolution(requirementIdForCreate);
    this.$router.push({
      name: 'CreateSolution',
    });
  }
  private refreshSolutions() {
    this.resetSearchParams();
    this.initSolutions(this.solutionInfoForSearch);
  }
  private resetSearchParams() {
    this.searchByStatus = 'All';
    this.searchByKeyword = '';
  }
  private initSolutions(params?: ISearchSolution) {
    this.listSpinning = true;
    this.solutionListInstance.requestData(params).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.listSpinning = false;
    });
  }
  private removeSolutionInfoForSearch() {
    this.solutionInfoForSearch = {};
    this.searchTags.length = 0;
  }
  private removeSearchParams(key: keyof ISearchSolution) {
    delete this.solutionInfoForSearch[key];
    this.searchTags = searchParamsConvertArray(this.solutionInfoForSearch);
    this.refreshSolutions();
  }
  private showSearchModal() {
    this.searchModalRef.showModal();
  }
  private handleModalSearch(params: ISearchSolution) {
    this.solutionInfoForSearch = params;
    this.searchTags = searchParamsConvertArray(this.solutionInfoForSearch);
    this.refreshSolutions();
  }
  private getMoreData() {
    this.addLoading = true;
    this.solutionListInstance
    .requestMoreData()
      .catch((err) => 'requestMoreSolutions err' + err)
      .finally(() => {
        this.addLoading = false;
      });
  }
  private handleItemClick(solution: ISolutionInfo) {
    this.solutionListInstance.list.changeCurrent(solution);
  }
  private refreshDetail(solution: ISolutionInfo) {
    this.detailSpinning = true;
    this.solutionListInstance
      .requestDetail({id: solution.id})
      .catch((err) => {
        if (err !== 'CANCEL') {
          this.$message.warning(err);
        }
      })
      .finally(() => {
        this.detailSpinning = false;
      });
  }
  private editSolution(solution: ISolutionInfo) {
    this.solutionListInstance.changeEditItem(solution);
    this.$router.push({
      name: 'UpdateSolution',
    });
  }
  private deleteSolution(solutionId: string) {
    this.solutionListInstance.requestDeleteById(solutionId).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private changeStatus(params: {
    solution: ISolutionInfo;
    status: ISolution.ISolutionStatus;
  }) {
    this.solutionListInstance.requestUpdateStatus(
      params.solution,
      params.status,
    );
  }
  private changeLabel(params: {
    solution: ISolutionInfo;
    labels: ILabelInfo[];
  }) {
    this.solutionListInstance.updateLabel(params.solution, params.labels);
  }
  private changeComment(params: {
    type: 'ADD' | 'CHANGE';
    solution: ISolutionInfo;
    comment: ICreateOrUpdateComment;
  }) {
    const { type, solution, comment } = params;
    this.solutionListInstance.updateComment(type, solution, comment);
  }
  private bindEvent() {
    changeStatusEventToken = pubsub.subscribe(CHANGE_SOLUTION_STATUS, (
      message: string,
      data: {solutionIds: string[], status: ISolution.ISolutionStatus}) => {
      for (const solution of solutionListInstance.list.data) {
        if (data.solutionIds.includes(solution.id) && solution.status !== data.status) {
          solutionListInstance.list.updateItem({...solution, status: data.status});
        } else {
          continue;
        }
      }
    });
  }
  private unBindEvent() {
    pubsub.unsubscribe(changeStatusEventToken);
  }
}
